var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.343 3.089c.4-.16.86-.101 1.202.155s.51.668.44 1.076l-1.806 10.416c-.175 1.005-1.334 1.58-2.303 1.08a47 47 0 0 1-3.097-1.737c-.541-.336-2.2-1.415-1.996-2.183.175-.657 2.962-3.123 4.554-4.59.625-.576.34-.908-.398-.378-1.833 1.316-4.775 3.317-5.748 3.88-.858.497-1.305.581-1.84.497-.976-.155-1.882-.394-2.62-.686-.999-.393-.95-1.699-.001-2.079z",
    clipRule: "evenodd"
  })));
};
export default SvgTelegram;